var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgV(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #aab2b7;\n        stroke: #aab2b7;\n        stroke-width: .5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_White_Comment",
    "data-name": "Icon White Comment"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Bounds",
    className: "cls-1",
    d: "m0,0h40v40H0V0Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fast-forward-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "cls-2",
    d: "m20.19,27.8c-.06,0-.12-.02-.18-.04-.13-.07-.21-.2-.21-.35v-6.94l-10.2,7.25c-.06.05-.14.07-.22.07-.06,0-.12-.02-.18-.04-.13-.07-.21-.2-.21-.35v-14.81c0-.15.08-.28.21-.35.13-.07.28-.06.4.03l10.2,7.25v-6.94c0-.21.17-.39.38-.39.08,0,.16.02.23.07l10.42,7.42c.18.13.22.37.09.55-.02.03-.06.07-.09.09l-10.42,7.41c-.07.04-.14.07-.22.07Zm.39-14.47v13.32l9.36-6.66-9.36-6.66h0Zm-10.81,0v13.32l9.36-6.65-9.37-6.66h0Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgV);
export default __webpack_public_path__ + "static/media/v.4adc98c45fd7165a5ad7c75b94ce31fc.svg";
export { ForwardRef as ReactComponent };